import { forwardRef } from 'react';
import type { Ref } from 'react';

import { Divider as MuiDivider } from '@mui/material';
import { Divider as DsDivider } from '@natter-co/design-system';
import { VISUAL_REFRESH } from 'common/utils';

import { toDsProps } from './toDsProps';

import type { DividerProps as MuiDividerProps } from '@mui/material';

export type DividerProps = MuiDividerProps & {
  /** Typed because hyphenated JSX attributes are unchecked; `toDsProps` has to see it. */
  'data-testid'?: string;
};

export const Divider = forwardRef<HTMLHRElement, DividerProps>((props, ref) => {
  // The visual-refresh gate lives here, not at the call sites. `null` falls through to MUI.
  const dsProps = VISUAL_REFRESH ? toDsProps(props) : null;

  if (!dsProps) return <MuiDivider ref={ref} {...props} />;

  const { orientation, className, testId } = dsProps;

  return (
    <DsDivider ref={ref as Ref<HTMLDivElement>} orientation={orientation} className={className} data-testid={testId} />
  );
});
